import { Link } from "react-router-dom";
import { Newspaper, Users, Leaf, ArrowRight } from "lucide-react";

const Row = ({ img, title, sub }) => (
  <div className="flex items-center gap-3 py-2.5 border-b border-slate-100 last:border-0 group">
    <img src={img} alt="" className="w-12 h-12 rounded-xl object-cover shrink-0" />
    <div className="min-w-0">
      <p className="text-sm font-bold text-slate-800 leading-snug line-clamp-2 group-hover:text-pink-600 transition-colors">{title}</p>
      <p className="text-xs text-slate-500 line-clamp-1">{sub}</p>
    </div>
  </div>
);

const Panel = ({ icon: Icon, color, title, sub, linkTo, linkLabel, children, testId }) => (
  <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-6" data-testid={testId}>
    <div className="flex items-start gap-3 mb-4">
      <span className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${color}`}><Icon className="w-5 h-5" /></span>
      <div>
        <h2 className="font-display text-xl font-black text-slate-900">{title}</h2>
        <p className="text-xs text-slate-500">{sub}</p>
      </div>
      <Link to={linkTo} className="ml-auto text-xs font-bold text-pink-600 hover:text-pink-700 inline-flex items-center gap-1 shrink-0">
        {linkLabel} <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
    {children}
  </div>
);

export const BottomTriad = ({ news = [], stories = [], heritage = [] }) => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
    <Panel icon={Newspaper} color="bg-indigo-100 text-indigo-600" title="Music News" sub="Latest updates from the global music scene." linkTo="/news" linkLabel="View All News" testId="home-news-panel">
      {news.map((n) => (
        <Link key={n.slug} to="/news" className="block"><Row img={n.image} title={n.title} sub={new Date(n.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })} /></Link>
      ))}
    </Panel>
    <Panel icon={Users} color="bg-pink-100 text-pink-600" title="Community Stories" sub="Real people. Real places. Real connections through music." linkTo="/community" linkLabel="All Stories" testId="home-stories-panel">
      {stories.map((s) => (
        <Link key={s.id} to="/community" className="block"><Row img={s.image} title={s.title} sub={`${s.author}, ${s.location}`} /></Link>
      ))}
    </Panel>
    <Panel icon={Leaf} color="bg-emerald-100 text-emerald-600" title="Preserving Musical Heritage" sub="Celebrating and safeguarding the world's musical traditions." linkTo="/hall-of-fame" linkLabel="Learn More" testId="home-heritage-panel">
      {heritage.map((h) => (
        <Row key={h.id} img={h.image} title={h.title} sub={h.blurb} />
      ))}
      <p className="mt-3 font-script text-2xl text-emerald-600 -rotate-1">Our heritage plays on ♪</p>
    </Panel>
  </section>
);

export default BottomTriad;
